import schoolLogo from '../assets/logo.jpg';
import heroBanner from '../assets/banner-image.png';

export const schoolImages = {
  logo: schoolLogo,
  hero: heroBanner
};
